export default __webpack_public_path__ + "static/media/Head_4_Ear_1_C3.26ee7129.svg";